import * as Common from '_common';
import { RenderDashboardRoomButton, RenderDashboardRoomFull, RenderHotWaterPumpButtonRender, RenderProcessButton, } from './Dashboard';
import { GraphsRender } from './Graphs';
import * as React from 'react';
export function houseComponentRegister(type) {
    switch (type) {
        case 'graphs':
            return GraphsRender;
        case 'dashboardroombutton':
            return RenderDashboardRoomButton;
        case 'dashboardroomfull':
            return RenderDashboardRoomFull;
        case 'hotwaterpumpbutton':
            return RenderHotWaterPumpButtonRender;
        case 'processbutton':
            return RenderProcessButton;
    }
}
export function useHouseWidgets() {
    const spa = Common.useSpaContext();
    const result = React.useMemo(() => {
        const result = [];
        const state = spa.state;
        if (state) {
            for (const item of Object.keys(state)) {
                const stateItem = state[item];
                if (stateItem.type?.toLowerCase() === 'room') {
                    const widget = {
                        id: item,
                        title: {
                            en: stateItem.name || item,
                            cs: stateItem.name || item,
                        },
                        components: {},
                    };
                    result.push(widget);
                }
            }
        }
        if (spa.process) {
            for (const process of Object.keys(spa.process)) {
                const processInfo = spa.process[process];
                if (!processInfo || processInfo === 'null') {
                    continue;
                }
                const widget = {
                    id: 'process-' + process,
                    title: {
                        en: processInfo.name || 'Process',
                        cs: processInfo.name || 'Process',
                    },
                    components: {
                        [Common.WidgetSize.Frame]: {
                            type: 'Process',
                            properties: { id: process },
                        },
                    },
                    defaultPlacement: {
                        type: Common.WidgetPlaceholderType.Floating,
                        size: Common.WidgetSize.Frame,
                        isDefault: true,
                        x: 'calc(100% - 800px - 2rem)',
                        y: 'calc(100% - 300px - 1rem)',
                        width: 400,
                        height: 300,
                    },
                };
                result.push(widget);
            }
        }
        return result;
    }, [spa]);
    return result;
}
// export function Cmp(component: Common.IComponent, index?: number): React.ReactNode {
// }
